import { Navigation } from '../../modules/Navigation';
import { MainWrapper } from '../../components/MainWrapper';
import { PrivacyPolicy } from '../../modules/PrivacyPolicy';
import { META_DESCRIPTION, TITLES } from '../../lib/constants';
import { Helmet } from 'react-helmet';

export const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>{TITLES.privacy}</title>
        <meta name="description" content={META_DESCRIPTION.privacy} />
      </Helmet>
      <MainWrapper>
        <Navigation />
        <PrivacyPolicy />
      </MainWrapper>
    </>
  );
};
